// The HUD palette for the Pixi map. The CSS tokens in styles.css hold the same values (theme.test.ts
// keeps them in sync); change both together.
export const MAP_COLORS = {
  own: 0x22d3ee,
  ally: 0x34d399,
  player: 0xf59e0b,
  unowned: 0x5b6b82,
  gate: 0x1e3a5f,
  shield: 0x67e8f9,
  selected: 0xfbbf24,
  sector: 0x475569,
  hostile: 0xf87171,
  label: 0x8aa0bc,
  labelFaint: 0x5d6f88,
} as const;
